const INITIAL_STATE = {
  data: {},
  errors: {},
}
      
const reportPdf = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_REPORT_PDF_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'GET_REPORT_PDF_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
      
export default reportPdf;